Core.ClientAddressBook = {
    init: function () {
        var _self = this;

        Core.ClientAddressBook.Cache = {
            $searchInputText: $('.client-address-book__search-input'),
            $searchRemoveButton: $('.client-address-book__search-remove'),

            $btnAddNew: $('.btn-addnew'),

            $popupView: $('#viewEditClient'),
            $popupNew: $('#addNewClient'),

            $btnFilter: $('#btnFilter'),
            $btnReset: $('#btnReset'),
            $portalDropdown: $('select#dropdownOrganization'),

            initialGroupId: $('select#dropdownOrganization').val(), // get default portal id
        };

        _self.prepareDropdown();
        _self.initSearch();
        _self.searchInputText();
        _self.removeSearchText();

        _self.handleShowDropDownActions();

        _self.handleBtnViewEdit();
        _self.handleBtnsAdd();
        _self.handleBtnFilter();
        _self.handleBtnReset();
    },


    /*

        SEARCH
        - initSearch: init letter and buttons

     */

    initSearch: function() {
        // search icon
        $('.client-address-book__search-button').on('click', Core.ClientAddressBook.getClients);

        // Letter filter
        $('.btn-addressfilter').on('click', function (e) {
            e.preventDefault();
            $('.btn-addressfilter').removeClass('is-selected');
            $(this).addClass('is-selected');
            Core.ClientAddressBook.getClients();
        });

        // input typing
        $('#SearchTextFilter').on('keyup', function (e) {
            //enter
            if (e.which == 13 || e.keyCode == 13) {
                Core.ClientAddressBook.getClients();
            }

            //escape
            if (e.which == 27 || e.keyCode == 27) {
                Core.ClientAddressBook.Cache.$searchRemoveButton.trigger('click');
            }
        });
    },

    searchInputText: function() {
        Core.ClientAddressBook.Cache.$searchInputText.on('input', function () {
            if ((this.value).trim(" ") != "")
                Core.ClientAddressBook.Cache.$searchRemoveButton.show(0);
            else
                Core.ClientAddressBook.Cache.$searchRemoveButton.hide(0);
        });
    },

    removeSearchText: function() {
        Core.ClientAddressBook.Cache.$searchRemoveButton.on("click", function () {
            Core.ClientAddressBook.Cache.$searchInputText.val("");
            Core.ClientAddressBook.getClients();
            Core.ClientAddressBook.Cache.$searchRemoveButton.hide(0);
        });
    },

    getClients: function() {
        Core.ShowPageLoading();

        var letter = $('.btn-addressfilter.is-selected').data('letter')
            , textFlt = $('#SearchTextFilter').val()
            , url = $('#client-address-book').data('url-getclients')
            , groupId= $('select[id=dropdownOrganization]').val()
            , param = {};

        if (letter) param.selectedFilterLetter = letter;
        if (textFlt) param.searchTextFilter = textFlt;
        if (groupId) param.groupId = groupId;

        if (!url) {
            console.warn("Can't find 'dataurl-getclients'. Returned early.");
            return;
        }

        $.ajax({
            url: url,
            type: 'GET',
            data: param,
            success: function(html) {
                $('#TableClientAddressBook').html(html);
                Core.ClientAddressBook.handleShowDropDownActions();
                Core.ClientAddressBook.handleBtnViewEdit();
                Core.HidePageLoading();
            },
            error: function(error) {
                console.log(error);
                Core.HidePageLoading();
            }
        });
    },


    /*

        DROP DOWN

     */

    prepareDropdown: function() {
        // prepend empty value
        $('#clientPopupResStateAdd').prepend("<option value=''></option>").val('');
        $('#clientPopupResStateAdd').prop('required', true);
    },

    handleShowDropDownActions: function() {
        function showNextDropDown(e) {
            var elUl = e.target.parentElement.querySelector('.client-address-book__drop-down__ul');

            elUl
                && elUl.classList
                && elUl.classList.remove('d-none');

            var elBtn = e.target.parentElement.querySelector('.client-address-book__drop-down__close');

            elBtn
                && elBtn.classList
                && elBtn.classList.remove('d-none');

            elBtn.addEventListener('click', function() {
                elUl.classList.add('d-none');
                elBtn.classList.add('d-none');
            });
        }

        $('.client-address-book__drop-down__action').on('click', showNextDropDown);
    },

    handleBtnViewEdit: function() {
        $('.btn-view').on('click', function () {
            var param = {
                email: this.dataset.email,
                contactid: this.dataset.contactid,
                url: this.dataset.url
            };

            var _self = Core.ClientAddressBook;
            var $popup = _self.Cache.$popupView;

            _self.getClient(param, function() { _self.initForm(ClientViewEditForm)($popup); });
        });
    },

    getClient: function(param, cb) {
        if (!param.url) {
            console.warn("Returned early. Couldn't find data-url. This should be set on the view/edit button");
            return;
        }

        Core.ShowPageLoading();
        $.ajax({
            url: param.url,
            type: 'GET',
            cache: false,
            data: {
                contactId: param.contactid
            },
            success: function (html) {
                $("#viewEditClient").find('.addressbook-body').html(html);
                if (cb) cb();
                Core.HidePageLoading();
            },
            error: function (error) {
                $(that).remove();
                DisplayError(error.statusText);
                Core.HidePageLoading();
            }
        });
    },

    handleBtnsAdd: function() {
        var _self = Core.ClientAddressBook;
        var $popup = _self.Cache.$popupNew;

        $('.btn-addnew').on('click', function() { _self.initForm(ClientAddForm)($popup); });
    },

    initForm: function(clientForm) {
        return function($form) {
            return (new clientForm($form)).init();
        };
    },

    handleBtnFilter: function() {
      var _self = Core.ClientAddressBook;
      var $btnFilter = _self.Cache.$btnFilter;

      $btnFilter.on('click', function() {
        _self.getClients();
      });
    },

    handleBtnReset: function() {
      var _self = Core.ClientAddressBook;
      var $btnReset = _self.Cache.$btnReset;
      var $portalDropdown = _self.Cache.$portalDropdown;
      var initialGroupId = _self.Cache.initialGroupId;

      $btnReset.on('click', function() {
        $portalDropdown.data("kendoDropDownList").value(initialGroupId);
        $('.btn-addressfilter').removeClass('is-selected');
        $('.btn-addressfilter:first').addClass('is-selected');
        _self.Cache.$searchRemoveButton.trigger('click');
      });
    },
}
